import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { CROSS_ICON, RED_DELETE_ICON } from "../../../constant";
import "../DailyQuotes/dailyQuotes.css";
import "../../UserManagement/UserManagementClinicianDetails/userManagementClinicianDetails.css";
import AddModalHoc from "../AddModalHoc/addModalHoc";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreator from "../../../modules/actions";
import { validateChar } from "../../../utils/validations";
import TextField from "../textField";
import "./procedures.css";

const AddEditProcedureQuestionModal = (props) => {
  const [termInvalid, setTermInvalid] = useState(false);
  const [meaningInvalid, setMeaningInvalid] = useState(false);
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const procedureQuestionData = props?.procedureQuestionData;
  const isEdit = props?.isEdit;

  const [data, setData] = useState({
    question: "",
    description: "",
    link_data: [],
    inputLink: {
      link: "",
      title: "",
      isValidLink: false,
      isValidTitle: false,
      isValidLinkData: false
    },
    isValidQuestion: false,
    isValidLink: false,
    isFormValid: false,
  });

  useEffect(() => {
    if (isEdit) {
      setData({
        question: procedureQuestionData?.question,
        description: procedureQuestionData?.description,
        link_data: procedureQuestionData?.link_data,
        inputLink: {
          link: "",
          title: "",
          isValidLink: false,
          isValidTitle: false,
          isValidLinkData: false
        },
        isValidQuestion: true,
        isValidLink: true,
        isFormValid: false,
      });
    }
  }, [isEdit]);

  const handleValidationOnBlur = (e, validattonData) => {
    const validation = {
      ...data,
      isValidQuestion: data.question.length > 10,
      isFormValid: data.question.length > 10,
    };
    setData(validation);
  };

  const handleInput = (e) => {
    let formData = { ...data };
    formData[e?.target?.name] = e.target.value;
    switch (e?.target?.name) {
      case "question":
        formData["isValidQuestion"] = formData.question.length > 10;
    }
    formData["isFormValid"] = formData.isValidQuestion;
    setData(formData);
  };

  const handleAddLink = () => {
    if (data.link_data) {
      setData({
        ...data,
        link_data: [...data.link_data, data.inputLink],
        inputLink: {
          link: "",
          title: "",
          isValidLink: false,
          isValidTitle: false,
          isValidLinkData: false
        },
      });
    } else {
      setData({ 
        ...data, 
        link_data: [data.inputLink], 
        inputLink: {
          link: "",
          title: "",
          isValidLink: false,
          isValidTitle: false,
          isValidLinkData: false
        }});
    }
  };

  const handleRemoveLink = (indexLink) => {
    setData({
      ...data,
      question: data?.question,
      description: data?.description,
      link_data: data?.link_data.filter((item, index) => index !== indexLink),
      inputLink: "",
    });
  };

  const handleLinkDataValidation = (e) => {
    let linkDataPayload = { ...data.inputLink };

    linkDataPayload[e.target.name] = e.target.value;


    switch(e.target.name) {
      case "link":
        linkDataPayload.isValidLink = data.inputLink?.link?.length > 5;
        break
      
      case "title":
        linkDataPayload.isValidTitle = data.inputLink?.title?.length > 0 && data.inputLink?.title?.length < 100;
        break
    };

    linkDataPayload.isValidLinkData = linkDataPayload.isValidLink && linkDataPayload.isValidTitle;
    setData({...data, inputLink: { ...data.inputLink, ...linkDataPayload }});
  };

  return (
    <>
      <Form noValidate>
        <Row>
          <Col style={{ paddingRight: "10px" }}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="modal-content-label">
                Question<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                onBlur={(e) => {
                  handleValidationOnBlur(e, data);
                }}
                type="text"
                placeholder="Ask Your Question!"
                className="input-field-content"
                name="question"
                value={data.question}
                width={100}
                onChange={(e) => {
                  handleInput(e);
                  submittedOnce
                    ? setTermInvalid(!validateChar(e.target.value))
                    : setTermInvalid(false);
                }}
                isInvalid={false}
              />
              {!data.isValidQuestion && data.question.length > 0 && (
                <span className="clinician-invalid" type="invalid">
                  Question field requires at least 10 characters.
                </span>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col className="link-form-container">
            <Form.Group className="continer-title" controlId="formBasicEmail">
              <Form.Label className="modal-content-label">Title</Form.Label>
              <Form.Control
                onBlur={(e) => {
                  handleValidationOnBlur(e, data);
                }}
                type="text"
                placeholder="Add link title!"
                className="input-field-content"
                value={data.inputLink.title}
                width={50}
                onChange={(e) => {
                  handleLinkDataValidation(e);
                  submittedOnce
                    ? setTermInvalid(!validateChar(e.target.value))
                    : setTermInvalid(false);
                }}
                isInvalid={termInvalid}
                name="title"
              />
            </Form.Group>
            <Form.Group className="continer-link" controlId="formBasicEmail">
              <Form.Label className="modal-content-label">Link</Form.Label>
              <Form.Control
                onBlur={(e) => {
                  handleValidationOnBlur(e, data);
                }}
                type="text"
                placeholder="Any Refrence Link!"
                className="input-field-content"
                value={data.inputLink.link}
                width={100}
                onChange={(e) => {
                  handleLinkDataValidation(e);
                  submittedOnce
                    ? setTermInvalid(!validateChar(e.target.value))
                    : setTermInvalid(false);
                }}
                isInvalid={termInvalid}
                name="link"
              />
            </Form.Group>
          </Col>
        </Row>
        <div>
          <span
            onClick={() => {
              data.inputLink.isValidLinkData && handleAddLink();
            }}
            className={`add-link-btn-chip ${!data.inputLink.isValidLinkData && "disable-btn"}`}
          >
            Add
          </span>
          {data.link_data?.length > 0 && (
            <div
              style={{
                marginBottom: "5px",
                marginLeft: "2px",
                marginRight: "5px",
              }}
            >
              {data.link_data?.map((elem, index) => (
                <div className="ellipsis">
                  <img
                    className="link-cross-icon"
                    src={CROSS_ICON}
                    alt=""
                    onClick={() => {
                      handleRemoveLink(index);
                    }}
                  />
                  {elem?.title || "No Title"} - {elem.link || "No Link"}
                </div>
              ))}
            </div>
          )}
        </div>
        <TextField
          label={"Description"}
          className={"text-field-content"}
          labelClassName={"textfield-content-label-glossary"}
          isInvalid={meaningInvalid}
          value={data.description}
          max={"2000"}
          onChange={handleInput}
          name="description"
          isNotNeccessary={true}
        />
      </Form>
      <div
        style={{
          display: "flex",
          marginTop: "45px",
          justifyContent: "flex-end",
        }}
      >
        {isEdit && (
          <span
            style={{
              backgroundColor: "transparent",
              border: "1px solid #ff6f59",
              cursor: "pointer",
              paddingTop: "8px",
              paddingBottom: "8px",
              width: "116px",
              borderRadius: "5px",
              color: "#ff6f59",
              display: "flex",
              gap: "5px",
              gap: "10px",
              paddingLeft: "16px",
              paddingRight: "16px",
              alignItems: "center",
              marginRight: "10px",
            }}
            className="apply-filter-button"
            onClick={() => {
              props?.handleDeleteProcedureQuestion(data);
            }}
          >
            Delete
            <img src={RED_DELETE_ICON} style={{ paddingTop: "1px" }} alt="" />
          </span>
        )}
        {!isEdit && (
          <span
            style={{
              cursor: "pointer",
              padding: "10px",
              width: "116px",
            }}
            className={`apply-filter-button ${
              !data.isFormValid && "disable-btn"
            }`}
            onClick={() => {
              if (data.isFormValid) {
                props?.handleAddQuestion(data);
              }
            }}
          >
            + Add
          </span>
        )}
        {isEdit && (
          <span
            style={{
              cursor: "pointer",
              padding: "10px",
              width: "116px",
            }}
            className={`apply-filter-button ${
              !data.isFormValid && "disable-btn"
            }`}
            onClick={() => {
              if (data.isFormValid) {
                props?.handleEditProcedureQuestion(data);
              }
            }}
          >
            Update
          </span>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  try {
    return {
      user: state.user.profile,
      details: state.userManagementDetails.details,
      loader: state.loader.mainLoader,
      glossary: state.contentDetails,
      fullHospitals: state.fullHospitals,
      userRole: state.user.profile.role,
      hospitalDetails: state.hospitalDetails,
    };
  } catch (e) {
    console.log(e);
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      reset: actionCreator.reset,
      addGlossary: actionCreator.addGlossary,
      toggleMainLoader: actionCreator.toggleMainLoader,
      updateGlossary: actionCreator.updateGlossary,
      getFullHospitals: actionCreator.getFullHospitals,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddModalHoc(AddEditProcedureQuestionModal));
